import { render, staticRenderFns } from "./newSearchProtocol.vue?vue&type=template&id=0bb7d8f2&"
import script from "./newSearchProtocol.vue?vue&type=script&lang=js&"
export * from "./newSearchProtocol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports